const MenuIcon = ({ width = 30, height = 11, color = "#EDD2B9", className = "", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 11"
      fill="none"
      className={className}
      {...props}
    >
      <path d="M1 1H29" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M1 10H29" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default MenuIcon;
